import { FC } from "react";

import { SvgIconConstituentValues } from "types/common";

export const ServerIconNew: FC<SvgIconConstituentValues> = props => (
  <svg
    fill="#646965"
    height="800px"
    width="800px"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 61 61"
    {...props}
  >
    <g>
      <path d="M22,53.5H1c-0.552,0-1,0.447-1,1s0.448,1,1,1h21c0.552,0,1-0.447,1-1S22.552,53.5,22,53.5z" />
      <path d="M60,53.5H38c-0.552,0-1,0.447-1,1s0.448,1,1,1h22c0.552,0,1-0.447,1-1S60.552,53.5,60,53.5z" />
      <path
        d="M25.207,46.707l5.207-5.207h24.978c2.541,0,4.608-2.067,4.608-4.608V25.108c0-0.974-0.314-1.868-0.835-2.608H0.835
		C0.314,23.24,0,24.135,0,25.108v11.783C0,39.433,2.067,41.5,4.608,41.5h22.978l-3.793,3.793L25.207,46.707z M52,31.5
		c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S51.448,31.5,52,31.5z M50,28.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1
		S49.448,28.5,50,28.5z M48,31.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S47.448,31.5,48,31.5z M46,28.5c0.552,0,1,0.448,1,1
		s-0.448,1-1,1s-1-0.448-1-1S45.448,28.5,46,28.5z M44,31.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S43.448,31.5,44,31.5z
		 M42,28.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S41.448,28.5,42,28.5z M40,31.5c0.552,0,1,0.448,1,1s-0.448,1-1,1
		s-1-0.448-1-1S39.448,31.5,40,31.5z M38,28.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S37.448,28.5,38,28.5z M36,31.5
		c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S35.448,31.5,36,31.5z M34,28.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1
		S33.448,28.5,34,28.5z M10.5,35.5C8.019,35.5,6,33.481,6,31s2.019-4.5,4.5-4.5S15,28.519,15,31S12.981,35.5,10.5,35.5z"
      />
      <path
        d="M34.793,44.293l-5.254,5.254C27.001,49.783,25,51.901,25,54.5c0,2.757,2.243,5,5,5s5-2.243,5-5
		c0-2.048-1.24-3.807-3.006-4.58l4.213-4.213L34.793,44.293z M33,54.5c0,1.654-1.346,3-3,3s-3-1.346-3-3s1.346-3,3-3
		S33,52.846,33,54.5z"
      />
      <path
        d="M59.165,20.5C59.686,19.76,60,18.865,60,17.892V6.108C60,3.567,57.933,1.5,55.392,1.5H4.608C2.067,1.5,0,3.567,0,6.108
		v11.783c0,0.974,0.314,1.868,0.835,2.608H59.165z M52,12.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S51.448,12.5,52,12.5z
		 M50,9.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S49.448,9.5,50,9.5z M48,12.5c0.552,0,1,0.448,1,1s-0.448,1-1,1
		s-1-0.448-1-1S47.448,12.5,48,12.5z M46,9.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S45.448,9.5,46,9.5z M44,12.5
		c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S43.448,12.5,44,12.5z M42,9.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1
		S41.448,9.5,42,9.5z M40,12.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S39.448,12.5,40,12.5z M38,9.5c0.552,0,1,0.448,1,1
		s-0.448,1-1,1s-1-0.448-1-1S37.448,9.5,38,9.5z M36,12.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S35.448,12.5,36,12.5z
		 M34,9.5c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S33.448,9.5,34,9.5z M10.5,7.5c2.481,0,4.5,2.019,4.5,4.5
		s-2.019,4.5-4.5,4.5S6,14.481,6,12S8.019,7.5,10.5,7.5z"
      />
    </g>
  </svg>
);
